export enum RoofProfile {
    Metal = "Металлочерепица",
    Prof = 'Профнастил'
}

export enum RoofType {
    Lamonterra  = "Ламонтерра",
    Monterosso  = "Монтерроса",
    Montekristo = "Монтекристо",
    Tramontana  = "Трамонтана",
    С_08        = "С08",
    С_21        = "С21",
    МП_20       = "МП20"
}

export enum RoofThickness {
    "DEFAULT"        = "",
    "THICK_40"       = "0,4 Стандарт",
    "THICK_45"       = "0,45 Стандарт+",
    "THICK_50"       = "0,5",
    "THICK_80"       = "0,8",
    "THICK_90"       = "0,9",
    "THICK_100"      = "1,0",
    "THICK_120"      = "1,2",
    "THICK_40_PLAIN" = "0,4",
    "THICK_45_PLAIN" = "0,45",
}

export enum RoofCoating {
    Polyester        = 'полиэстер',
    Norman           = 'Norman',
    Purman           = 'Purman',
    VikingMP         = 'VikingMP E',
    Poly_Norman      = 'полиэстер Norman',
    Zinc             = 'цинк',
    Ecosteel         = 'Ecosteel',
    PureTechMat      = 'PureTech Mat',
    Valori           = 'VALORI',
    Puretan          = 'Puretan',
    MattMP           = 'Matt MP',
    VikingMPStandard = 'VikingMP',
    SteelMatt        = 'SteelMatt',
}
